import { ComponentProps } from "react";
import { Interpolation, Theme, css, useTheme } from "@emotion/react";
import { Text } from "components/core/Text";

export const BoldText = ({
  children,
  ...props
}: Omit<ComponentProps<typeof Text>, "variant"> & {
  css?: Interpolation<Theme>;
}) => {
  const theme = useTheme();
  return (
    <Text
      variant="h4"
      css={css`
        color: ${(theme as any).mode === "dark"
          ? theme.palette.common.white.main
          : theme.palette.text.primary};
      `}
      {...props}
    >
      {children}
    </Text>
  );
};
